import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/weight_based_shipping_rule'
import WeightBasedShippingRuleService from '../../network/services/weightBasedShippingRule'
import { serialize } from '../../network/request'
import WeightBasedShippingRuleTable from './WeightBasedShippingRuleTable'

const WeightBasedShippingRulePage = () => {
  const navigate = useNavigate()

  const newAction = (
    <>
      <Button
        key={'new'}
        type="primary"
        onClick={() => {
          navigate('/dashboard/weight_based_shipping_rule/new')
        }}
      >
        New Weight Based Shipping Rule
      </Button>
    </>
  )

  return (
    <PageHeader title="Weight Based Shipping Rules" extra={[newAction]}>
      <Card>
        <WeightBasedShippingRuleWrapper />
      </Card>
    </PageHeader>
  )
}

const WeightBasedShippingRuleWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(WeightBasedShippingRuleService.getAll, {
      page: 1,
      limit: state.pageSize,
      refresh: state.refresh,
      ...state.filters
    })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = WeightBasedShippingRuleService.toPaginate(response)

  return (
    <>
      <WeightBasedShippingRuleTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <WeightBasedShippingRuleTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default WeightBasedShippingRulePage
